import { useCrumbs } from "@/components/layout/CrumbsContext";
import { NewAuditView } from "@/components/plan-audit/NewAuditView";

export function NewAuditPage({ solution }: { solution?: string }) {
  useCrumbs([{ label: "Solutions", to: "/solutions" }, { label: "New audit" }]);
  return (
    <>
      <div className="pa-page-head">
        <div>
          <h1>New audit</h1>
          <p>
            Uploading and filing are one action. Choose an existing solution or name a new one; the
            intake takes as many files as the intake took.
          </p>
        </div>
      </div>
      <NewAuditView preselectedSolution={solution} />
    </>
  );
}
